var o;!function(o){o.BORDER_BOX="border-box",o.CONTENT_BOX="content-box",o.DEVICE_PIXEL_CONTENT_BOX="device-pixel-content-box"}(o||(o={}));export{o as ResizeObserverBoxOptions};
//# sourceMappingURL=ResizeObserverBoxOptions.js.map
